import React, { useEffect, useState } from 'react';
import Card from '../Card/Card';
import RepeatingFields from '../RepeatingFields/RepeatingFields';
import OrganizationItem from '../OrganizationItem/OrganizationItem';
import NewOrganization from '../NewOrganization/NewOrganization';
import useOrgsDocsQuery from '../../queries/useOrgsDocsQuery';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';

const Organizations = ({ form }) => {
  const [visibleModal, setVisibleModal] = useState(false);

  const { mode } = useSelector(documentDrawerSelector);

  const companyId = form.getFieldValue('serviceCompanyId');

  const { data, isFetching } = useOrgsDocsQuery(companyId, {
    enabled: Boolean(companyId),
  });

  useEffect(() => {
    if (mode === 'edit') return;

    form.setFieldsValue({
      orgsKeys: [0],
    });
  }, [companyId]);

  return (
    <>
      <Card heading="Адресат">
        <RepeatingFields
          form={form}
          formKey={'orgsKeys'}
          addButtonText="Добавить организацию"
          renderOneItem={(index, allowDelete, deleteItem) => (
            <OrganizationItem
              form={form}
              index={index}
              allowDelete={allowDelete}
              deleteItem={deleteItem}
              data={data}
              isFetching={isFetching}
            />
          )}
          onClickBtn={() => setVisibleModal(true)}
          openText="Создать"
          isDisabled={!companyId}
        />
      </Card>
      <NewOrganization
        visible={visibleModal}
        onCancel={() => setVisibleModal(false)}
        serviceCompanyId={companyId}
      />
    </>
  );
};

export default Organizations;
